import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=3b4b576c&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4b576c')) {
      api.createRecord('3b4b576c', component.options)
    } else {
      api.reload('3b4b576c', component.options)
    }
    module.hot.accept("./AppLogo.vue?vue&type=template&id=3b4b576c&", function () {
      api.rerender('3b4b576c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppLogo.vue"
export default component.exports